import { useCallback, useEffect, useState } from 'react';

import { useAttachmentSignedUrl } from 'hooks/useAttachmentSignedUrl';

export function useClickAttachment(attachmentId: string, attachableModel?: string, page?: number) {
  const [attachmentToFetchId, setAttachmentToFetchId] = useState<string>('');

  const { data: attachmentData, isStale, refetch } = useAttachmentSignedUrl(attachmentToFetchId, attachableModel);

  const openUrl = (url: string) => {
    const target = typeof page === 'number' ? `${url}#page=${page}` : url;
    window.open(target, '_blank');
  };

  const openAttachment = useCallback(() => {
    if (isStale) {
      refetch();
    } else if (attachmentData?.url) {
      openUrl(attachmentData.url);
    } else {
      setAttachmentToFetchId(attachmentId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [attachmentId, isStale, attachmentData?.url, refetch, page]);

  useEffect(() => {
    if (attachmentData?.url) {
      openUrl(attachmentData.url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [attachmentData?.url]);

  return openAttachment;
}
